import { BehaviorSubject } from 'rxjs';
import { IApplyData, IPageConfigurationData } from './page-configuration.interface';

export class ConfigurationDialogManager {
  public readonly configurationsSubject: BehaviorSubject<IPageConfigurationData | null> =
    new BehaviorSubject<IPageConfigurationData | null>(null);

  public readonly isPageConfigurationDisabledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  public readonly onApply = new BehaviorSubject<IApplyData<string | number> | null>(null);
}
